export default{sources:{avif:"__VITE_ASSET__DgPcsxUq__ 400w",webp:"__VITE_ASSET__BWajVLSh__ 400w"},img:{src:"__VITE_ASSET__D0Nd5gf5__",w:400,h:267}};